import {
  afterSuccessfulResolution,
  addHealthInsurance,
  setNewInsuranceSelectedTile,
  enableDisableNextStep
} from './checkout_insurance_helper';
import { formPost, jsonGet } from '../components/ajax';
import { API_REFERENCE } from '../utilities/constant_api';
import * as constantConfig from '../utilities/constant_config';

const clsCheckoutInsEditable = '.insurance-checkout__editable';
const clsInsuranceSaveBtn = '.insurance-save-container';
const hiddenClass = 'hidden';
const clsParentInsurance = '.checkout-insurance';
const clsInsuranceErrorSection = '.checkout-insurance__error';
const clsPopRadio = '.pop-radio-button';
const clsAddExpInsRadio = '.insurance-res-options__option';
const payOutCheckboxNoPayerCls = '.insurance-payer__check--nopayer';
const payOutCheckboxPayerCls = '.insurance-payer__check--payer';
const addInsuranceWrapperClass = '.checkout-add-insurance-wrapper';
const insNextBtnId = '#ins-next-btn';
const strPromote = 'ins-promote-select';
const strBirthMonth = 'birth-month-select-dropdown';
const strBirthDay = 'birth-day-select-dropdown';
const strBirthYear = 'birth-year-select-dropdown';
const strGender = 'gender-select-dropdown';
const strFirstName = 'ins_first_name_id';
const strLastName = 'ins_last_name_id';
const firstNameId = `input[id^=${strFirstName}]`;
const lastNameId = `input[id^=${strLastName}]`;
const birthMonthId = `select[id^=${strBirthMonth}]`;
const birthDayId = `select[id^=${strBirthDay}]`;
const birthYearId = `select[id^=${strBirthYear}]`;
const policyNbrId = 'input[id^=policy_number_id]';
const phoneNbrId = 'input[id^=phone_number_id]';
const promoteId = `select[id^=${strPromote}]`;
const genderIdSelector = `select[id^=${strGender}]`;
const selectClass = '.insurance-option-wrapper__field--select';
const inputClass = '.insurance-option-wrapper__field--input';
const clsSaveBtn = '.insurance-save-btn';
const clsNextBtn = '.insurance-next-btn';
const clsRadioWrapper = '.add-ins-radio-wrapper';
const strClsSaveBtnParent = 'insurance-save__container--height';
const clsCheckoutInsuranceForm = '.checkout-insurance__form';
const clsCheckoutInsuranceNextForm = '.checkout-insurance__next-form';
const clsCheckoutPopField = '.checkout-insurance__pop-field';
const dobMismatch = 'dobMismatch';
const policyMismatch = 'policyMismatch';
const phoneMismatch = 'phoneMismatch';
const genderMismatch = 'genderMismatch';
const promoteInsurance = 'promoteInsurance';
const cancelOrder = 'cancelOrder';
const addNewInsurance = 'addNewInsurance';
const payOutOfPocket = 'pop';
const phoneNumberMissing = 'phoneNumberMissing';
const inactivePayerPosition = 'inactivePayerPosition';
const inactiveCustomerPlanRltId = 'inactiveCustomerPlanRltId';
const dataCustomerRltId = 'data-custRltId';
const dataPosition = 'data-position';
const dataAction = 'data-action';
const dataPlanId = 'data-planId';
const dataVal = 'data-val';
const insuranceErrorsId = '#insurance-errors';
const $addExpInsRadio = $(`${clsParentInsurance} ${clsAddExpInsRadio}`);
const $PopRadio = $(`${clsParentInsurance} ${clsPopRadio}`);
const $insuranceErrorSections = $(clsInsuranceErrorSection);
const $firstNameLastNamePolicyNbr = $(
  `${firstNameId},${lastNameId},${policyNbrId},${phoneNbrId}`
);
const $selectClass = $(`${clsParentInsurance} ${selectClass}`);
const $saveBtn = $(`${clsParentInsurance} ${clsSaveBtn}`);
const $nextBtn = $(`${insuranceErrorsId} ${clsNextBtn}`);
const $planPhoneNumber = $('.planPhoneNo');
const $payOutOfPocketChkBoxes = $(
  `${payOutCheckboxNoPayerCls},${payOutCheckboxPayerCls}`
);
let updateCheckoutInsuranceInfoAjaxFlag = true;
let popRadioButtonSelected = false;
let nextStepButtonAction = false;
const updateInformationUrl = `${ACC.config.encodedContextPath}${API_REFERENCE.checkoutInsurance.updateInsuranceInformation}`;
const continueToNextStepUrl = `${ACC.config.encodedContextPath}${API_REFERENCE.checkoutInsurance.continueToNextStep}`;
const retrieveInsuranceSelectionUrl = `${ACC.config.encodedContextPath}${API_REFERENCE.checkoutInsurance.retrieveInsurance}`;
const promoteInsuranceUrl = `${ACC.config.encodedContextPath}${API_REFERENCE.checkoutInsurance.updatePromoteInsurance}`;
const checkoutInsurance = {
  // Function which is called when the pay out of pocket checkbox is checked or unchecked
  payOutCheckboxClick() {
    const checkedCheckbox = $(this).prop('checked');
    if (checkedCheckbox) {
      $(addInsuranceWrapperClass).hide();
      $(insNextBtnId).attr('disabled', false);
      $insuranceErrorSections.hide();
    } else {
      $(addInsuranceWrapperClass).show();
      enableDisableNextStep();
      $insuranceErrorSections.show();
    }
  },
  proceedWithPayOutOfPocket() {
    $(insNextBtnId).attr('disabled', false);
    $insuranceErrorSections.hide();
  },
  payOutOfPocketRadioClick() {
    const thisParent = $(this).parents('.insurance-save-container');
    popRadioButtonSelected = true;
    $(insNextBtnId).attr('disabled', false);
    thisParent.find(clsInsuranceSaveBtn).addClass(hiddenClass);
  },
  validateDropdowns(editableSection) {
    let requiredFieldCount = 0;
    editableSection.find(selectClass).each((index, item) => {
      const $item = $(item);
      const selectedOption = $item.find('option:selected');
      const itemVal = selectedOption.length ? selectedOption.val().length : 0;
      if (!itemVal) {
        requiredFieldCount = 1;
        return false;
      }
      return true;
    });
    return requiredFieldCount;
  },

  populatePromoteInsuranceDropdown(
    editableSection,
    $parentSection,
    saveBtnParent
  ) {
    const editableSelectedSectionSelect = editableSection.find(promoteId);
    const saveBtn = $parentSection.find(clsSaveBtn);
    $(editableSelectedSectionSelect)
      .find('option[value!=""]')
      .remove();
    const customerPlanRltId = $parentSection.attr(dataCustomerRltId);
    jsonGet(retrieveInsuranceSelectionUrl, $.param({ customerPlanRltId })).then(
      response => {
        const payerList = response.listCHHPayerInfo;
        let newPayerOption = '';
        $.each(payerList, (index, item) => {
          newPayerOption += `<option value=${
            item.customerPlanRltId
          }>${item.planName.trim()}</option>`;
        });
        $(editableSelectedSectionSelect).append(newPayerOption);
        // resetting selection to disabled Select option
        $(editableSelectedSectionSelect)
          .find('option:nth-child(1)')
          .prop('selected', true);
        const promoteInsuranceChildren = $(editableSelectedSectionSelect)
          .find('option')
          .not('option[value=""]').length;
        if (promoteInsuranceChildren > 1) {
          $(editableSection).removeClass(hiddenClass);
          // adding class to reset min-height
          saveBtnParent.addClass(strClsSaveBtnParent);
        } else if (promoteInsuranceChildren === 1) {
          // select the single insurance available to use during submission
          $(editableSelectedSectionSelect)
            .find('option[value!=""]')
            .prop('selected', true);
          saveBtn.attr('disabled', false);
        }
      }
    );
  },

  validateAndResetInputFields(editableSection, reset) {
    let requiredFieldCount = 0;
    editableSection.find(inputClass).each((index, item) => {
      const $item = $(item);
      if (reset) {
        const originalVal = $item.attr(dataVal);
        $item.val(originalVal);
      }
      if (item.validity.valueMissing) {
        requiredFieldCount = 1;
      }
    });
    return requiredFieldCount;
  },
  // To Hide or Show editable section
  hideShowEditableSection() {
    const thisParent = $(this).parents(clsInsuranceErrorSection);
    const actionAttr = $(this).attr(dataAction);
    const radioBtnParent = $(this).parents(clsRadioWrapper);
    const editableSection = $(radioBtnParent).find(clsCheckoutInsEditable);
    const saveBtnParent = thisParent.find('.insurance-save-container');
    if (actionAttr === payOutOfPocket) {
      thisParent.find(clsInsuranceSaveBtn).addClass(hiddenClass);
      thisParent.find(clsCheckoutInsEditable).addClass(hiddenClass);
    } else {
      thisParent.find(clsInsuranceSaveBtn).removeClass(hiddenClass);
    }
    if (actionAttr === promoteInsurance) {
      checkoutInsurance.populatePromoteInsuranceDropdown(
        editableSection,
        thisParent,
        saveBtnParent
      );
    }

    // reset editable sections
    // using min height class
    saveBtnParent.removeClass(strClsSaveBtnParent);
    thisParent.find(clsCheckoutInsEditable).addClass(hiddenClass);

    // reset all dropdowns in tile to original value
    // to add data-val to selects during integration

    thisParent.find('option[data-val="selected"]').prop('selected', true);
    // add action to button
    thisParent.find(clsSaveBtn).data('action', actionAttr);
    if (editableSection.length) {
      popRadioButtonSelected = false;
      const selectValid =
        checkoutInsurance.validateDropdowns(editableSection) === 1;
      const inputValid =
        checkoutInsurance.validateAndResetInputFields(editableSection, true) ===
        1;
      // reset add information field with original prepopulated value
      thisParent.find(clsSaveBtn).attr('disabled', selectValid || inputValid);
      // do not show the promote insurance dropdown if there is only one other active insurance
      if (actionAttr !== promoteInsurance && actionAttr !== payOutOfPocket) {
        $(editableSection).removeClass(hiddenClass);
        // adding class to reset min height
        saveBtnParent.addClass(strClsSaveBtnParent);
      }
    }
    // For Cancel Order option and add new insurance option
    if (actionAttr === cancelOrder || actionAttr === addNewInsurance || actionAttr === payOutOfPocket) {
      thisParent.find(clsSaveBtn).attr('disabled', false);
    }
  },

  validateCheckoutDropdowns() {
    const thisObj = $(this);
    const parentSection = thisObj.parents(clsInsuranceErrorSection);
    const radioBtnParent = $(this).parents(clsRadioWrapper);
    const editableSection = $(radioBtnParent).find(clsCheckoutInsEditable);
    const saveButton = $(parentSection).find(clsSaveBtn);
    let selectInvalidFields = false;
    selectInvalidFields =
      checkoutInsurance.validateDropdowns(editableSection) === 1;
    saveButton.attr('disabled', selectInvalidFields);
  },

  validateCheckoutInputFields() {
    const thisObj = $(this);
    const parentSection = thisObj.parents(clsInsuranceErrorSection);
    const radioBtnParent = $(this).parents(clsRadioWrapper);
    const editableSection = $(radioBtnParent).find(clsCheckoutInsEditable);
    const saveButton = $(parentSection).find(clsSaveBtn);
    let inputInvalidFields = false;
    inputInvalidFields =
      checkoutInsurance.validateAndResetInputFields(editableSection, false) ===
      1;
    saveButton.attr('disabled', inputInvalidFields);
  },
  validatePlanPhoneNumber() {
	  const thisObj = $(this);
	  const parentSection = thisObj.parents(clsInsuranceErrorSection);
	  const saveButton = $(parentSection).find(clsSaveBtn);
    if (thisObj.val().length == 12) {
	  const actionAttr = thisObj.attr(dataAction);
	  saveButton.data('action', actionAttr);
      saveButton.attr('disabled',false);
    } else {
	  saveButton.data('action', '');
      saveButton.attr('disabled',true);
    }
  },
  updateInsuranceInformation(thisObj, parent) {
    const actionAttr = thisObj.data('action');
    const formParent = thisObj.parents(clsCheckoutInsuranceForm);
    const customerPlanRltIdCommon = $(parent).attr(dataCustomerRltId);
    let requiredStr = `&${actionAttr}=true&customerPlanRltId=${customerPlanRltIdCommon}`;
    let submitUrl = updateInformationUrl;
    $('.global-error-message-container').addClass('hidden');
    if (actionAttr === genderMismatch) {
      const genderFieldVal = $(parent)
        .find(genderIdSelector)
        .find('option:selected')
        .val();
      requiredStr += `&gender=${genderFieldVal}`;
    } else if (actionAttr === dobMismatch) {
      const yearVal = $(parent)
        .find(birthYearId)
        .find('option:selected')
        .val();
      const monthVal = $(parent)
        .find(birthMonthId)
        .find('option:selected')
        .val();
      const dayVal = $(parent)
        .find(birthDayId)
        .find('option:selected')
        .val();
      const dateVal = `${monthVal}/${dayVal}/${yearVal}`;
      requiredStr += `&dateOfBirth=${dateVal}`;
    } else if (actionAttr === promoteInsurance) {
      submitUrl = promoteInsuranceUrl;
      const selectedInsuranceVal = parent
        .find(`${promoteId} option:selected`)
        .val();
      const selectedPayerPosition = $(parent).attr(dataPosition);
      const customerPlanRltId = $(parent).attr(dataCustomerRltId);
      requiredStr += `&${promoteInsurance}Id=${selectedInsuranceVal}&${inactivePayerPosition}=${selectedPayerPosition}&${inactiveCustomerPlanRltId}=${customerPlanRltId}`;
    }
    const selectedPlanId = $(parent).attr(dataPlanId);
    requiredStr += `&planId=${selectedPlanId}`;
    const requiredData = formParent.serialize() + requiredStr;
    if (!updateCheckoutInsuranceInfoAjaxFlag) return false;
    updateCheckoutInsuranceInfoAjaxFlag = false;
    formPost(submitUrl, requiredData)
      .then(response => {
        updateCheckoutInsuranceInfoAjaxFlag = true;
        const statusText = response !== '' ? JSON.parse(response) : {};
        if (statusText.status === constantConfig.SUCCESS) {
          afterSuccessfulResolution();
        } else if (
          statusText.errorMessage !== '' &&
          statusText.errorMessage !== null &&
          statusText.errorMessage !== undefined
        ) {
          $('.global-error-message-container')
            .removeClass('hidden')
            .find('.generic-error-text')
            .text(statusText.errorMessage);
          window.scrollTo(0, 0);
        }
      })
      .catch(error => {
        updateCheckoutInsuranceInfoAjaxFlag = true;
      });
  },

  cancelOrderFromInsurance() {
    window.location.href = `${ACC.config.encodedContextPath}${API_REFERENCE.cart.cancelOrder}`;
  },

  resolveError() {
    const thisObj = $(this);
    const actionAttr = thisObj.data('action');
    const parent = $(this).parents(clsInsuranceErrorSection);
    const errorSubType = parent.attr('data-subtype');
    const insuranceObject = {};
    if (errorSubType === constantConfig.EXPIRED_INSURANCE) {
      insuranceObject.errorSubtype = errorSubType;
      insuranceObject.payerPosition = parent.attr('data-position');
      insuranceObject.planIdToBeRemoved = parent.attr('data-planId');
      insuranceObject.customerPlanRltIdToBeRemoved = parent.attr(
        'data-custRltId'
      );
    }
    setNewInsuranceSelectedTile(parent);
    if (actionAttr === addNewInsurance) {
      addHealthInsurance(thisObj, insuranceObject);
    } else if (
      actionAttr.toLowerCase().indexOf('mismatch') !== -1 ||
      actionAttr === promoteInsurance
    ) {
      checkoutInsurance.updateInsuranceInformation(thisObj, parent);
    } else if (actionAttr === cancelOrder) {
      checkoutInsurance.cancelOrderFromInsurance();
    }  else if(actionAttr === phoneNumberMissing) {
      checkoutInsurance.updateInsuranceInformation(thisObj, parent);
    } else if(actionAttr === payOutOfPocket) {
      checkoutInsurance.proceedWithPayOutOfPocket(thisObj, parent);
    }
  },

  resetErrorTiles() {
    // reset form
    $(clsCheckoutInsuranceForm).trigger('reset');
    // reset dropdowns
    $('option[data-val="selected"]').prop('selected', true);
    $(promoteId)
      .find('option:nth-child(1)')
      .prop('selected', true);
    // reset input fields
    $(inputClass).each(function(index, item) {
      const $item = $(item);
      const originalVal = $item.attr('data-val');
      $item.val(originalVal);
    });
    // hide editable sections
    $(clsCheckoutInsEditable).addClass(hiddenClass);
    // disable save and next buttons
    $saveBtn.attr('disabled', true);
    $nextBtn.attr('disabled', true);
  },

  // Moving to next step
  submitNextValidation() {
    const payOutOfPocketLen =
      $(`${payOutCheckboxPayerCls}:checked`).length ||
      $(`${payOutCheckboxNoPayerCls}:checked`).length || popRadioButtonSelected;
    const nextForm = $(clsCheckoutInsuranceNextForm);
    $(clsCheckoutPopField).val(false);
    if (payOutOfPocketLen) {
      $(clsCheckoutPopField).val(true);
    }
    if(!nextStepButtonAction){
      nextStepButtonAction = true;
      $(nextForm).attr('action', continueToNextStepUrl);
      $(nextForm).submit();
    }
  },

  init() {
    this.resetErrorTiles();
    $payOutOfPocketChkBoxes.on('click', this.payOutCheckboxClick);
    $PopRadio.on('click', this.payOutOfPocketRadioClick);
    $addExpInsRadio.on('click', this.hideShowEditableSection);
    $selectClass.selectmenu({
      classes: {
        'ui-selectmenu-open': 'checkout-insurance__selectmenu'
      }
    });
    $selectClass.on('selectmenuchange', this.validateCheckoutDropdowns);
    $firstNameLastNamePolicyNbr.on('input', this.validateCheckoutInputFields);
    $planPhoneNumber.on('input', this.validatePlanPhoneNumber);
    $saveBtn.on('click', this.resolveError);
    $(document).on(
      'click',
      `${clsParentInsurance} ${clsNextBtn}`,
      this.submitNextValidation
    );
  }
};
checkoutInsurance.init();

export default checkoutInsurance;
